module.exports = __webpack_public_path__ + "img/world.d294131.svg";